import React from 'react';
import { Icon } from '@mui/material';
import './Custom-Icon-Box.scss';

const CustomIconBox = (props) => {
  const { icon, title, isActive, onClickTab, iconType, activityNdx, iconSelected } = props;
  return (
    <div className='custom-icon-box' onClick={() => onClickTab(activityNdx)}>
      <div className={isActive ? 'box-select' : 'box'}>
        <div className='col col-md-12'>
          {iconType === 'image' ? (
            <img src={isActive ? iconSelected : icon} className='image' alt={title} />
          ) : (
            <Icon className='icon'>{icon}</Icon>
          )}
        </div>
        <div className='col col-md-12 title'>{title}</div>
      </div>
    </div>
  );
};

export default CustomIconBox;
